import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.state';
import { AgGridIconButtonRendererModel } from 'src/app/shared/models/ag-grid-icon-button-renderer.model';
import {
  ProjectDeliverableWithCheckMappingsViewModel,
  ProjectDeliverableWithMappingsViewModel,
} from 'src/app/shared/models/autogenerated';
import { AdapCellClassRules } from 'src/app/shared/utils/ag-grid-utils';
import { nameof } from 'src/app/shared/utils/nameof';
import { DeliverableManagerGridCellActionsModel } from '../../../../../shared/models/deliverable-manager-grid-cell-actions.model';
import {
  DELIVERABLE_MANAGER_TABLE_DA_CONFIG_STORE,
  DELIVERABLE_MANAGER_TABLE_PROJECT_CONFIG_STORE,
} from '../../screening.constants';
import { deleteMappingsForProjectDeliverable } from '../../store/screening.actions';
import { DeliverableManagerCommonTableComponent } from '../deliverable-manager-common-table/deliverable-manager-common-table.component';
import { ProjectDeliverableTableRendererComponent } from 'src/app/shared/components/project-deliverable-table-renderer/project-deliverable-table-renderer.component';
import { ProjectDeliverableTitleGridCell } from 'src/app/shared/models/project-deliverable-title-grid-cell.model';
import { ExportableColDefWithTitle } from 'src/app/shared/ag-grid-config/store/ag-grid-config/ag-grid-config.reducer';

@Component({
  standalone: false,
  selector: 'app-deliverable-manager-project-deliverable-table',
  templateUrl:
    '../deliverable-manager-common-table/deliverable-manager-common-table.component.html',
  styleUrls: [
    '../deliverable-manager-common-table/deliverable-manager-common-table.component.scss',
  ],
})
export class DeliverableManagerProjectDeliverableTableComponent extends DeliverableManagerCommonTableComponent<ProjectDeliverableWithMappingsViewModel> {
  configStoreTableName: string = DELIVERABLE_MANAGER_TABLE_PROJECT_CONFIG_STORE;

  columnDefs: ExportableColDefWithTitle[] = [
    {
      checkboxSelection: true,
      resizable: false,
      minWidth: 50,
      maxWidth: 50,
      type: 'centerAligned',
      pinned: 'left',
    },
    {
      ...this.tagsColumn,
      cellRendererParams: {
        onInit: (data: any, actions: any) => {
          this.titleToTagsActions = actions;
          this.setTagsToTitleActions(
            'Set deliverable title as tags in DA filter',
            (data: any) => {
              this.sendTagsToFilter(
                this.store,
                DELIVERABLE_MANAGER_TABLE_DA_CONFIG_STORE,
                data.name
              );
            }
          );
        },
      } as AgGridIconButtonRendererModel,
      ignoreExport: true,
    },
    {
      headerName: 'Map',
      colId: 'map',
      minWidth: 90,
      maxWidth: 90,
      pinned: 'left',
      filter: 'agNumberColumnFilter',
      valueGetter: (params) => params.data.daDeliverableIdList?.length ?? 0,
      cellClassRules: AdapCellClassRules,
      type: 'centerAligned',
      cellRenderer: 'deliverableManagerMappingRenderer',
      cellRendererParams: {
        onMappingClick: (data: ProjectDeliverableWithMappingsViewModel) =>
          this.setFilterByDeliverableIds.emit(data.daDeliverableIdList),
        onDeleteClick: (id) =>
          this.deleteConfirmationDialog(this.store, () =>
            this.deleteMappings(id)
          ),
      } as DeliverableManagerGridCellActionsModel,
    },
    {
      field: nameof<ProjectDeliverableWithMappingsViewModel>('contractor'),
      headerName: 'Contractor',
      resizable: true,
      width: 150,
      hide: true,
    },
    {
      field: nameof<ProjectDeliverableWithMappingsViewModel>('name'),
      headerName: 'Title',
      resizable: true,
      tooltipField: nameof<ProjectDeliverableWithMappingsViewModel>('name'),
      cellRenderer: ProjectDeliverableTableRendererComponent,
      valueGetter: (params: {
        data: ProjectDeliverableWithCheckMappingsViewModel;
      }) =>
        ({
          projectDeliverableTitle: params.data.name,
          isCarryOver: params.data.isCarryOver,
          displayAsLinkToOtt: false,
        } as ProjectDeliverableTitleGridCell<ProjectDeliverableWithCheckMappingsViewModel>),
      getQuickFilterText: (params: {
        data: ProjectDeliverableWithMappingsViewModel;
      }) => params.data.name,
      exportValueGetter: (params) => {
        return params.projectDeliverableTitle;
      },
    },
    {
      field: nameof<ProjectDeliverableWithMappingsViewModel>('type'),
      headerName: 'Type',
      resizable: true,
      width: 80,
    },
    {
      field: nameof<ProjectDeliverableWithMappingsViewModel>('discipline'),
      headerName: 'Discipline',
      resizable: true,
      width: 100,
    },
    {
      field: nameof<ProjectDeliverableWithMappingsViewModel>('isSSR'),
      headerName: 'Sample Set Review',
      resizable: true,
      width: 100,
      cellDataType: 'string',
      valueFormatter: (params) => (params.value === true ? 'Yes' : 'No'),
    },
  ];

  constructor(private store: Store<AppState>) {
    super();
  }

  private deleteMappings(projectDeliverableId: string) {
    this.deselectAllInBothTables.emit();
    this.store.dispatch(
      deleteMappingsForProjectDeliverable({
        projectDeliverableId,
      })
    );
  }
}
